import React from "react";
import { useLocation } from "react-router";

import TopNavigation from "../Layouts/TopNavigation";
import { noNavigationRoutes, publicRoutesName } from "../Utils/utils";

const NavigationWrapper = ({ show = ["private"], runQueries = true }) => {
  const { pathname } = useLocation();
  let myRoutes = show.includes("private") ? noNavigationRoutes : [];
  myRoutes = show.includes("public") ? publicRoutesName : [];

  return (
    myRoutes.filter((item) => pathname.includes(item)).length === 0 && (
      <TopNavigation runQueries={runQueries} />
    )
  );
};

export default NavigationWrapper;
